import { Injectable, NgZone } from '@angular/core';
import { ContextFactory } from '@shared/factories/context/context.factory';

@Injectable({
  providedIn: 'root'
})
export class ChatBotService {
  loaded: boolean = false;
  private landbotInstance: any = null;
  private allowedHosts: string[] = [
    'centinelafigma.affin.es',
    'centinela.lefebvre.es'
  ];
  private productMap = new Map<string, number>([
    ['none', 0],
    ['garbage', 1],
    ['index', 2],
    ['lefebvre01', 104],
    ['dataprotv2', 105],
    ['hitos', 106],
    ['esg', 107],
    ['phh', 108],
    ['glegalc', 109],
    ['lefebvre', 112],
    ['cm', 114],
    ['cpda', 25],
    ['denunc', 26],
    ['bpt', 28],
    ['encuestas', 3],
    ['train', -3],
    ['drake', 36],
    ['ggcc1', 39],
    ['ggcc2', 40],
    ['gramaudit1', 41],
    ['cliprivacy', 42],
    ['blanqueo', 44],
    ['privac', 46],
    ['bpt002', 47],
    ['mkt001', 48],
    ['adaptalia', 52],
    ['one', 64],
    ['gestion', 7],
    ['personas', 71],
    ['igualdad', 72],
    ['poc', 75],
    ['forms', 77],
    ['penal004', 79],
    ['igualdad02', 85],
    ['antifraude', 86],
    ['penal', 88],
    ['taxvice', 9],
    ['gpap', 90],
    ['kit', 91],
    ['penal006', 93],
    ['laboral', 95],
    ['licit', 96],
  ]);

  scriptLoaded: boolean = false;

  constructor(
    private context: ContextFactory,
    private zone: NgZone
  ) { }

  initLandbot(): void {
    this.zone.runOutsideAngular(() => {
      const schedule = (cb: () => void) =>
        (window as any).requestIdleCallback
          ? (window as any).requestIdleCallback(cb, { timeout: 2000 })
          : setTimeout(cb, 0);

      schedule(() => this._initLandbot());
    });
  }

  private _initLandbot(): void {
    this.loaded = true;
    const currentHost = window.location.hostname;

    const isAllowed = this.allowedHosts.some(host =>
      currentHost === host
    );

    const isLandingPage =
      location.pathname.includes('public/') ||
      location.pathname.includes('shared/') ||
      location.pathname.includes('contact-login') ||
      location.pathname.includes('preview-customization') ||
      location.pathname.includes('office-online/');

    if (!isAllowed || isLandingPage) return;

    if (this.scriptLoaded && (window as any).Landbot) {
      this.startChat();
      return;
    }

    if (document.querySelector('script[src*="landbot-3.js"]')) {
      this.scriptLoaded = true;
      this.startChat();
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://static.landbot.io/landbot-3/landbot-3.js';
    script.async = true;

    script.onload = () => {
      this.scriptLoaded = true;
      this.startChat();
    };

    document.head.appendChild(script);
  }

  startChat(): void {
    this.zone.runOutsideAngular(() => {
      if (!(window as any).Landbot) return;

      this.landbotInstance = new (window as any).Landbot.Livechat({
        configUrl: window.location.hostname === 'centinelafigma.affin.es'
          ? 'https://storage.googleapis.com/landbot.pro/v3/H-3325960-EQY3ZTDAFEIJHED8/index.json'
          : 'https://storage.googleapis.com/landbot.pro/v3/H-3325957-3AXWE2D1H25AP1VP/index.json',
        customData: {
          name: this.context.user?.fullName || '',
          origin: 'https://centinela.lefebvre.es',
          entrada: this.context.user?.externalId || '',
          subArea: this.context.settings?.externalId
            ? this.context.settings?.externalId
            : this.productMap.get(this.context.settings.defaultProduct)
        },
      });
    });
  }

  reloadLandbot(): void {
    this.logOut();
    this.initLandbot();
  }

  logOut() {
    // Destruye la instancia actual
    this.landbotInstance?.destroy();
    this.landbotInstance = null;

    // Elimina el script del DOM
    const script = document.querySelector('script[src*="landbot-3.js"]');
    script?.remove();

    // Limpia el objeto global
    delete (window as any).Landbot;
    this.scriptLoaded = false;
    this.loaded = false;
  }
}